import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden bg-gradient-to-br from-secondary/30 via-background to-card">
      <div className="absolute inset-0 z-0">
        <Image
          src="https://images.unsplash.com/photo-1587241321921-91a834d6d191"
          alt="Warm rustic Italian bakery interior with wooden shelves displaying fresh artisan breads and pastries, vintage brick walls, and soft natural lighting creating an inviting traditional atmosphere"
          className="w-full h-full object-cover opacity-20" />

        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/80 to-transparent" />
      </div>

      <div className="container-custom relative z-10 py-20">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-6">
            <Icon name="Heart" size={18} color="var(--color-primary)" />
            <span className="text-sm font-medium text-primary">Est. 1985</span>
          </div>

          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl font-bold text-foreground mb-6 leading-tight">
            Our Italian Story
          </h1>

          <p className="text-xl md:text-2xl text-muted-foreground mb-8 leading-relaxed">
            Where generations of passion meet daily craftsmanship, creating authentic Italian traditions in the heart of Etobicoke
          </p>

          <div className="flex flex-wrap items-center justify-center gap-6 text-sm">
            <div className="flex items-center gap-2">
              <Icon name="Award" size={20} color="var(--color-accent)" />
              <span className="text-foreground font-medium">4.7 Stars</span>
            </div>
            <div className="w-1 h-1 rounded-full bg-border" />
            <div className="flex items-center gap-2">
              <Icon name="Users" size={20} color="var(--color-accent)" />
              <span className="text-foreground font-medium">471+ Reviews</span>
            </div>
            <div className="w-1 h-1 rounded-full bg-border" />
            <div className="flex items-center gap-2">
              <Icon name="Clock" size={20} color="var(--color-accent)" />
              <span className="text-foreground font-medium">40 Years Legacy</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <Icon name="ChevronDown" size={32} color="var(--color-primary)" />
      </div>
    </section>);

};

export default HeroSection;